import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deleteVehicleColumnOption } from '../../actions/apiDepartmentUpdates';

class DisplayOptions extends Component {
	constructor(props) {
		super(props);
		this.state = { value: this.props.value };
		this.deleteOption = this.deleteOption.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		this.setState({ value: e.value });
	}

	deleteOption(e) {
		const id = e.target.dataset.dbid;
		const errorType = 'delete option';
		const { column_id } = this.props;
		this.props.deleteVehicleColumnOption(id, column_id, errorType);
	}

	render() {
		const options = this.props.options || [];
		let cols = [];

		if (typeof options !== 'undefined') {
			cols = options.map(option => <li className="list-group-item" key={`opt_${option.id}`}>
				{option.name}
				{' '}
				<button className="btn btn-sm btn-danger float-end" data-dbid={option.id} onClick={this.deleteOption}>x</button>
                                                    </li>);
		}

		return (
			<div className="p-2">
				<div className="showOptions">
					<ul className="list-group">
						<li className="list-group-item blockquote text-center">Add/Delete Options</li>
						{cols}
					</ul>
				</div>
			</div>

		);
	}
}

const mappedActions = {
	deleteVehicleColumnOption,
};

function mapStateToProps(state) {
	return {};
}
export default connect(mapStateToProps, mappedActions)(DisplayOptions);
